import VMMixin from './vm'
import ServicesMixin from './services'
import ErrorsMixin from './errors'
import FormattersMixin from './formatters'

export default [ErrorsMixin, FormattersMixin, ServicesMixin, VMMixin]
